import { DeviceTypesProvider } from '@root/src/core/contexts/device-types';
import { SettingsDevicesCustomAlarmFormContainer } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-form/settings-devices-custom-alarm-form.container';

export const SettingsDevicesCustomAlarmsFormScene = () => (
    <DeviceTypesProvider>
        <SettingsDevicesCustomAlarmFormContainer />
    </DeviceTypesProvider>
);

export default SettingsDevicesCustomAlarmsFormScene;
